const UNICODE_TO_ASCII_MAP: Record<string, string> = {
  '\u2013': '-', // EN DASH –
  '\u2014': '-', // EM DASH —
  '\u2018': "'", // LEFT SINGLE QUOTATION MARK '
  '\u2019': "'", // RIGHT SINGLE QUOTATION MARK '
  '\u201A': "'", // SINGLE LOW-9 QUOTATION MARK ‚
  '\u201B': "'", // SINGLE HIGH-REVERSED-9 QUOTATION MARK ‛
  '\u201C': '"', // LEFT DOUBLE QUOTATION MARK "
  '\u201D': '"', // RIGHT DOUBLE QUOTATION MARK "
  '\u201E': '"', // DOUBLE LOW-9 QUOTATION MARK „
  '\u201F': '"', // DOUBLE HIGH-REVERSED-9 QUOTATION MARK ‟
  '\u2212': '-', // MINUS SIGN −
};

const NORMALIZE_REGEX = /[\u2013\u2014\u2018\u2019\u201A\u201B\u201C\u201D\u201E\u201F\u2212]/g;

/**
 * Normalizes Unicode typographic punctuation to ASCII equivalents for search comparison.
 * All replacements are 1:1 (one Unicode char → one ASCII char), so string positions are preserved.
 * This means indexOf() results on the normalized string are valid indices into the original string.
 */
export const normalizeForSearch = (text: string): string =>
  text.replace(NORMALIZE_REGEX, (char) => UNICODE_TO_ASCII_MAP[char] ?? char);
